import dayjs, { Dayjs } from 'dayjs';

export const SAME_DATE_TEMPLATE = 'YYYY/MM/DD';

export const convertDateToSingleFormat = (
  date: string | number | Dayjs | Date
) => dayjs(date).format(SAME_DATE_TEMPLATE);
